import * as THREE from 'three';

import { ActiveData, CAMERA_DISTANCE } from './ElvaVisualizerMeasurements';
import { getKeypointId, getSafeSkeleton, getMeasurementValuesByName } from './helpers';
import { LOCK_TYPE } from './types';
import { MeasurementFocusParams } from './useMeasurementFocus';
import { computeIntrinsicCameraParams, computePlaneCameraParams } from './utils/rotationUtils';

export function getNumericValue(value: unknown): number | undefined {
    return typeof value === 'number' ? value : undefined;
}
function getKeypointPosition(
    activeData: NonNullable<ActiveData>,
    frame: number,
    keypointName: string,
): THREE.Vector3 | null {
    const keypointId = getKeypointId(keypointName, activeData.keypointIdToName);
    const position = getSafeSkeleton(activeData.skeleton, frame, keypointId);

    if (!position) {
        return null;
    }

    return new THREE.Vector3(position[1], position[2], position[0]);
}
export function getLockedCameraParams(
    activeData: NonNullable<ActiveData>,
    frame: number,
    focus: MeasurementFocusParams,
) {
    const { keypointName, lock, targetPoints } = focus;

    if (lock.type === LOCK_TYPE.INTRINSIC) {
        const eulerAngles = getMeasurementValuesByName(activeData.measurements, lock.measurementName, frame) as
            | [number, number, number]
            | null;

        const targetPoint = getKeypointPosition(activeData, frame, keypointName);

        if (!eulerAngles || !targetPoint) {
            return null;
        }

        return computeIntrinsicCameraParams(eulerAngles, lock.axisIndex, targetPoint, CAMERA_DISTANCE);
    }

    if (lock.type !== LOCK_TYPE.PLANE || !targetPoints || targetPoints.length < 3) {
        return null;
    }

    const points = targetPoints.slice(0, 3).map((targetPoint) => getKeypointPosition(activeData, frame, targetPoint));

    if (!points[0] || !points[1] || !points[2]) {
        return null;
    }

    return computePlaneCameraParams(points as [THREE.Vector3, THREE.Vector3, THREE.Vector3], CAMERA_DISTANCE);
}
